import { render } from "./CreateCompanyForm.vue?vue&type=template&id=15280120&scoped=true&ts=true"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=ts"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=ts"

import "./CreateCompanyForm.vue?vue&type=style&index=0&id=15280120&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15280120"]])

export default __exports__